import React, { ReactNode } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  SxProps,
  Theme,
} from "@mui/material";
import {
  StyledDialogContainer,
  StyledDialogContent,
  StyledTitle,
  StyledModalStyles as styles,
} from "./StyledModal.styles";

interface IStyledModal {
  open: boolean;
  handleClose: () => void;
  contentText: string | ReactNode;
  title?: string;
  modalActions?: ReactNode;
  sx?: SxProps<Theme>;
  contentTestId?: string;
  titleSx?: {
    textAlign?: "center" | "left" | "right";
    color?: string;
    margin?: string;
  };
  isDialogPolicy?: boolean;
}

const StyledModal = ({
  open,
  handleClose,
  contentText,
  title,
  modalActions,
  sx = {},
  contentTestId,
  titleSx = {
    textAlign: "center",
    color: "black",
    margin: "0",
  },
  isDialogPolicy = false,
}: IStyledModal) => {
  return (
    <Dialog
      sx={[
        StyledDialogContainer(isDialogPolicy) as SxProps<Theme>,
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      open={open}
      onClose={handleClose}
      tabIndex={-1}
    >
      {title && (
        <DialogTitle sx={StyledTitle(isDialogPolicy)}>
          <Typography sx={titleSx} variant="h4">
            {title}
          </Typography>
        </DialogTitle>
      )}
      <DialogContent
        sx={StyledDialogContent(isDialogPolicy)}
        data-testid={contentTestId}
      >
        <Stack direction="row" spacing={1.5}>
          {contentText}
        </Stack>
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Box sx={styles.boxContainer}>{modalActions}</Box>
      </DialogActions>
    </Dialog>
  );
};

export default StyledModal;
